<script>
export default {
	methods: {
		onEscKeyDown(e) {
			if (e.keyCode === 27) {
				this.onEscape();
				return true;
			}
		},
		onEscape() {
			// do nothing by default
		}
	},
	mounted() {
		document.addEventListener('keydown', this.onEscKeyDown);
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.onEscKeyDown);
	},
}
</script>
